// extracted by mini-css-extract-plugin
module.exports = {"container":"Qb","copy":"Rb","field":"Sb","error":"Tb","disabled":"Ub","termsContainer":"Vb","termsHeading":"Wb","termsCopy":"Xb","submit":"Yb","srOnly":"Zb"};